import { useLocalReactionStore } from "designSystem/hooks";
import session from "csi/session";
import { routerStore } from "csi/state/rootStore";
import { LOCATION_PREVIOUS_URL } from "csi/utility/routerUtility";
import React, { FunctionComponent } from "react";
import { ManageProofStoreContext } from "./Proof/ManageProofStore";
import ViewProof from "./Proof/ViewProof";
import { createManageProofStore } from "./ProofService";

const ConnectToProof: FunctionComponent = () => {
	const manageProofStore = useLocalReactionStore(() => {
		if (!routerStore.targetPreviousUrl) {
			session.setLocationActual(LOCATION_PREVIOUS_URL, routerStore.previousLocationUrl);
		}
		return createManageProofStore();
	});

	return (
		<ManageProofStoreContext.Provider value={manageProofStore}>
			{manageProofStore && (
				<ViewProof  />
			)}
		</ManageProofStoreContext.Provider>
	);
};

export default ConnectToProof;
